define( function() {

/**
 * Determines whether an object can have data
 */
return function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};

} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/data/var/acceptData.js
 ** module id = 853
 ** module chunks = 2
 **/